"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slatePlugins = require("@udecode/slate-plugins");
var _element = _interopRequireDefault(require("./element"));
var _transforms = require("./transforms");
var _isUrl = _interopRequireDefault(require("../../../../utils/isUrl"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var upsertLink = function upsertLink(editor, url, options) {
  var _setDefaults = (0, _slatePlugins.setDefaults)(options, _element["default"]),
    at = _setDefaults.at,
    link = _setDefaults.link;
  (0, _slatePlugins.unwrapNodesByType)(editor, link.type, {
    at: at
  });
  var newSelection = editor.selection;
  (0, _transforms.wrapLink)({
    editor: editor,
    url: url,
    options: {
      at: _objectSpread(_objectSpread({}, at), {}, {
        focus: newSelection.focus
      })
    }
  });
};
var withLink = function withLink(options) {
  return function (editor) {
    var _setDefaults2 = (0, _slatePlugins.setDefaults)(options, _element["default"]),
      link = _setDefaults2.link;
    var insertData = editor.insertData,
      insertText = editor.insertText;
    editor.insertText = function (text) {
      if (text === ' ' && (0, _slatePlugins.isCollapsed)(editor.selection)) {
        var selection = editor.selection;
        var rangeFromBlockStart = (0, _slatePlugins.getRangeFromBlockStart)(editor);
        var textFromBlockStart = (0, _slatePlugins.getText)(editor, rangeFromBlockStart);
        if (rangeFromBlockStart && (0, _isUrl["default"])(textFromBlockStart)) {
          upsertLink(editor, textFromBlockStart, {
            at: rangeFromBlockStart
          });
          return insertText(text);
        }
        var beforeWordRange = (0, _slatePlugins.getRangeBefore)(editor, selection, {
          matchString: ' ',
          skipInvalid: true,
          afterMatch: true,
          multiPaths: true
        });
        if (beforeWordRange) {
          var beforeWordText = (0, _slatePlugins.getText)(editor, beforeWordRange);
          if ((0, _isUrl["default"])(beforeWordText)) {
            upsertLink(editor, beforeWordText, {
              at: beforeWordRange
            });
          }
        }
      }
      insertText(text);
    };
    editor.insertData = function (data) {
      var text = data.getData('text/plain');
      if (text && (0, _isUrl["default"])(text) && !(0, _slatePlugins.isNodeTypeIn)(editor, link.type)) {
        (0, _transforms.upsertLinkAtSelection)(editor, text, {
          link: link
        });
      } else {
        insertData(data);
      }
    };
    editor.wrapLink = _transforms.wrapLink;
    editor.upsertLinkAtSelection = _transforms.upsertLinkAtSelection;
    editor.setLink = _transforms.setLink;
    editor.unwrapLink = _transforms.unwrapLink;
    return editor;
  };
};
var _default = exports["default"] = withLink;